const entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};

export default {
  /**
   * Gets the script template matching a role
   *
   * @param  {Object} config
   * @return {HTMLNode}
   */
  getTemplate(config) {
    for (let i = 0; i < config.roles.length; i += 1) {
      const template = config.templates[config.roles[i]];
      if (template) {
        return template;
      }
    }

    return config.templates[config.status];
  },

  /**
   * Gets the script templates for the component
   *
   * @param  {Object} config
   * @return {Object}
   */
  getTemplates(config) {
    const templateTags = config.root.querySelectorAll('script[data-role]');
    const templates = {};
    for (let i = 0; i < templateTags.length; i += 1) {
      templates[templateTags[i].getAttribute('data-role')] = templateTags[i].innerHTML;
    }

    return templates;
  },

  /**
   * Replaces variables in a template
   *
   * @param  {Object} config
   * @param  {Object} data
   * @return {HTMLNode}
   */
  replaceVariables(template, data) {
    if (!data) {
      return template;
    }

    let component = template;
    Object.keys(data).forEach((key) => {
      const regex = new RegExp(`#{${key}}`, 'g');
      component = component.replace(regex, this.sanitizeInput(data[key]));
    });

    return component.replace(/#{\w+}/g, '');
  },

  /**
   * Sanitises strings to prevent Dom-based XSS
   *
   * @param  {String} string
   * @return {String}
   */
  sanitizeInput(string) {
    if (typeof string !== 'string') {
      return string;
    }

    return string.replace(/[&<>"'/]/g, s => entityMap[s]);
  }
};
